/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoAnalyticsModelsAvailabilityAppListItem,
    TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSON,
    TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped,
    TrackingMelcoAnalyticsModelsAvailabilityAppListItemToJSON,
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
 */
export interface TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    /**
     * 
     * @type {Array<TrackingMelcoAnalyticsModelsAvailabilityAppListItem>}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    list: Array<TrackingMelcoAnalyticsModelsAvailabilityAppListItem>;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    total: number;
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSON(json: any): TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    return TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json, false);
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemToJSON(value?: TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(TrackingMelcoAnalyticsModelsAvailabilityAppListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


